export default "__VITE_ASSET__9107e270__"